export enum PostStatus {
  DENIAL = 'denial',
  APPROVED = 'approved',
  PENDING = 'pending',
  SCHEDULED = 'scheduled',
  PUBLISHED = 'published',
}
